import api from './client';
import type { ClientVehicle } from 'types/client_vehicle';

/**
 * Client vehicles — the standalone `client_vehicles` collection (distinct from
 * the embedded dossier.vehicles[] and from the garage loaner /vehicles fleet).
 * Backend fields are already snake_case and match the ClientVehicle shape
 * (incl. owner/company/user party blocks), so no case-mapping is needed.
 */
export const clientVehiclesApi = {
  list: async (params?: {
    org_id?: string;
    dossier_id?: string;
    is_fleet?: boolean;
    limit?: number;
    offset?: number;
  }): Promise<ClientVehicle[]> => {
    const { data } = await api.get('/client-vehicles', { params });
    return data;
  },

  search: async (params: {
    plate?: string;
    org_id?: string;
    is_fleet?: boolean;
    limit?: number;
  }): Promise<ClientVehicle[]> => {
    const { data } = await api.get('/client-vehicles/search', { params });
    return data;
  },

  get: async (id: string): Promise<ClientVehicle> => {
    const { data } = await api.get(`/client-vehicles/${id}`);
    return data;
  },

  create: async (vehicle: Partial<ClientVehicle> & { org_id: string; plate: string }): Promise<ClientVehicle> => {
    const { data } = await api.post('/client-vehicles', vehicle);
    return data;
  },

  update: async (id: string, updates: Partial<ClientVehicle>): Promise<ClientVehicle> => {
    const { data } = await api.patch(`/client-vehicles/${id}`, updates);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/client-vehicles/${id}`);
  },
};
